import { useCallback } from 'react';

import { useDispatch } from 'react-redux';
import { setLocalStorageToReduxPersistenceData } from 'reducers/localStorageToReduxPersistenceDataSlice';

import useLocalStorage from './useLocalStorage';

/* 
  A custom hook to manage ag grid filter model persistence. 
  setLocalStorageToReduxPersistenceData is used to update the redux store with the latest filter model. For the use case of subscribing to filter changes
  This is pretty dumb hook and only add wrapper over localStorage hook. 
  In case this needs to handle something else, please upgrade this comment description to justify why the necessity.
*/

export const useAgGridPersistFilterModel = ({ key, gridRef }) => {
  const [persistedGridState, setPersistedFilterModel] = useLocalStorage(key, null);

  const dispatch = useDispatch();
  const persistedFilterModel = persistedGridState?.filterModel;

  const saveAppliedFilterModel = useCallback(() => {
    const currentFilterModel = gridRef?.current?.api?.getFilterModel();

    // console.log('currentFilterModel', currentFilterModel);

    setPersistedFilterModel((prev) => ({ ...prev, filterModel: currentFilterModel }));
    dispatch(setLocalStorageToReduxPersistenceData({ [key]: { filterModel: currentFilterModel } }));
  }, [gridRef, setPersistedFilterModel, dispatch, key]);

  const applyPersistedFilterModel = useCallback(() => {
    /* Read from localStorage */

    if (persistedFilterModel) {
      // adding setTimeout to ensure that the filter model is set after the grid is rendered
      setTimeout(() => {
        gridRef?.current?.api?.setFilterModel(persistedFilterModel);
        dispatch(setLocalStorageToReduxPersistenceData({ [key]: { filterModel: persistedFilterModel } }));
      }, 0);
    }
  }, [persistedFilterModel, gridRef, dispatch, key]);

  const applyCustomFilterModel = useCallback(
    (customFilterModel) => {
      gridRef?.current?.api?.setFilterModel(customFilterModel);
    },
    [gridRef]
  );

  return {
    persistedFilterModel,
    saveAppliedFilterModel,
    applyPersistedFilterModel,
    applyCustomFilterModel,
  };
};
